import { ILessonPlan, ILessonPlansParams, IShortItem, ITableRes } from 'types'

import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'

export const lessonPlansAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_lessonPlanOptions: builder.query<any, void>({
      query: () => ({
        url: '/group-course-session-plan-options/',
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['lesson-plan-options'],
    }),
    GET_lessonPlans: builder.query<ITableRes<ILessonPlan>, ILessonPlansParams>({
      query: (params) => ({
        url: '/group-course-session-plans/',
        params,
      }),
      providesTags: ['lesson-plans'],
    }),
    GET_lessonPlansSelect: builder.query<ITableRes<IShortItem>, any>({
      query: (params) => ({
        url: '/group-course-session-plans/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: ITableRes<IShortItem>): any => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['lesson-plans-select'],
    }),
    GET_lessonPlanById: builder.query<ILessonPlan, string>({
      query: (id) => {
        return {
          url: `/group-course-session-plans/${id}/`,
        }
      },
      providesTags: ['lesson-plan'],
    }),
    POST_lessonPlan: builder.mutation<ILessonPlan, ILessonPlan>({
      query: (body) => ({
        url: `/group-course-session-plans/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['lesson-plans','lesson-plan', 'curriculum-map'],
    }),
    PATCH_lessonPlan: builder.mutation<ILessonPlan, { id: string; body: ILessonPlan }>({
      query: ({ id, body }) => ({
        url: `/group-course-session-plans/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['lesson-plans', 'lesson-plan', 'curriculum-map'],
    }),
    DELETE_lessonPlan: builder.mutation<ILessonPlan, string>({
      query: (id) => ({
        url: `/group-course-session-plans/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['lesson-plans','lesson-plan', 'curriculum-map'],
    }),
  }),
})

export const {
  useGET_lessonPlanOptionsQuery,
  useGET_lessonPlansSelectQuery,
  useGET_lessonPlansQuery,
  useGET_lessonPlanByIdQuery,
  usePOST_lessonPlanMutation,
  usePATCH_lessonPlanMutation,
  useDELETE_lessonPlanMutation,
} = lessonPlansAPI
